import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'notEmpty'
})
export class NotEmptyPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    if ((value == null || value == undefined || value == '') && value !== 0) {
      if(args.length){ 
        return args[0]
      }
      return '-';
    } else {
      return value;
    }
  }

}
